import {
    GET_FEATURES,
    GET_USERS,
    GET_MACHINES,
    GET_EQUIPMENTS,
    GET_VEHICLE_ALERTS,
    SET_MONTH,
    SET_YEAR,
    GET_REPORT_TITLES,
    GET_DEPARTMENTS,
    GET_AREAS,
    GET_TOOLBOX,
    GET_TOOLBOX_TITLES,
    GET_ALL_REPORTS,
    GET_JOB_PACKS,
    GET_REPORTS,
    GET_USER_DEVICE_INFO

} from "./types";
import firebase from "firebase/app";
import { push } from "connected-react-router";
import "firebase/auth";
import "firebase/database";

export const getRecieptReports = () => {
    return (dispatch) => {
        dispatch({ type: GET_REPORTS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_REPORTS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/users")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_REPORTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_REPORTS.FAIL });
        }
    };
};
export const getFeatures = () => {
    return (dispatch) => {
        dispatch({ type: GET_FEATURES.REQUEST });

        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user === null) {
                    dispatch({ type: GET_FEATURES.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/subjects/features")
                        .on("value", (snapshot) => {
                            dispatch({
                                type: GET_FEATURES.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_FEATURES.FAIL });
        }
    };
};

export const getReports = () => {
    return (dispatch) => {
        dispatch({ type: GET_ALL_REPORTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/reports/`)
                        .on("value", (snapshot) => {
                            return dispatch({
                                type: GET_ALL_REPORTS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else dispatch({ type: GET_ALL_REPORTS.FAIL });
            });
        } catch {
            dispatch({ type: GET_ALL_REPORTS.FAIL });
        }
    };
};

export const getJobpacks = (year) => {
    return (dispatch) => {
        dispatch({ type: GET_JOB_PACKS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/jobpacks/active/${year}/`)
                        .on("value", (snapshot) => {
                            return dispatch({
                                type: GET_JOB_PACKS.SUCCESS,
                                payload: snapshot.val(),
                            });
                        });
                } else dispatch({ type: GET_JOB_PACKS.FAIL });
            });
        } catch {
            dispatch({ type: GET_JOB_PACKS.FAIL });
        }
    };
};

export const getUsers = () => {
    return (dispatch) => {
        dispatch({ type: GET_USERS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/users/`)
                        .on("value", (snapshot) =>
                            dispatch({
                                type: GET_USERS.SUCCESS,
                                payload: snapshot.val(),
                            })
                        );
                } else {
                    dispatch({ type: GET_USERS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_USERS.FAIL });
        }
    };
};

export const getReportTitles = () => {
    return (dispatch) => {
        dispatch({ type: GET_REPORT_TITLES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/report_titles/`)
                        .on("value", (snapshot) =>
                            dispatch({
                                type: GET_REPORT_TITLES.SUCCESS,
                                payload: snapshot.val(),
                            })
                        );
                } else {
                    dispatch({ type: GET_REPORT_TITLES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_REPORT_TITLES.FAIL });
        }
    };
};

export const getDepartments = () => {
    return (dispatch) => {
        dispatch({ type: GET_DEPARTMENTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/departments/`)
                        .on("value", (snapshot) =>
                            dispatch({
                                type: GET_DEPARTMENTS.SUCCESS,
                                payload: snapshot.val(),
                            })
                        );
                } else {
                    dispatch({ type: GET_DEPARTMENTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_DEPARTMENTS.FAIL });
        }
    };
};

export const getAreas = () => {
    return dispatch => {
        dispatch({ type: GET_AREAS.REQUEST });

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_AREAS.FAIL });
                } else {
                    firebase
                        .database()
                        .ref("/collections/areas")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_AREAS.SUCCESS,
                                payload: snapshot.val()
                            });
                        });
                }
            });
        } catch (e) {
            dispatch({ type: GET_AREAS.FAIL });
        }
    };
};

export const getToolboxTitles = () => {
    return (dispatch) => {
        dispatch({ type: GET_TOOLBOX_TITLES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/collections/toolbox_types/`)
                        .on("value", (snapshot) =>
                            dispatch({
                                type: GET_TOOLBOX_TITLES.SUCCESS,
                                payload: snapshot.val(),
                            })
                        );
                } else {
                    dispatch({ type: GET_TOOLBOX_TITLES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_TOOLBOX_TITLES.FAIL });
        }
    };
};

export const getToolbox = () => {
    return (dispatch) => {
        dispatch({ type: GET_TOOLBOX.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/toolbox/`)
                        .on("value", (snapshot) =>
                            dispatch({
                                type: GET_TOOLBOX.SUCCESS,
                                payload: snapshot.val(),
                            })
                        );
                } else {
                    dispatch({ type: GET_TOOLBOX.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_TOOLBOX.FAIL });
        }
    };
};

export const getMachines = () => {
    return (dispatch) => {
        dispatch({ type: GET_MACHINES.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/machines/`)
                        .on("value", (snapshot) =>
                            dispatch({
                                type: GET_MACHINES.SUCCESS,
                                payload: snapshot.val(),
                            })
                        );
                } else {
                    dispatch({ type: GET_MACHINES.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_MACHINES.FAIL });
        }
    };
};

export const getEquipments = () => {
    return (dispatch) => {
        dispatch({ type: GET_EQUIPMENTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/equipment/`)
                        .on("value", (snapshot) =>
                            dispatch({
                                type: GET_EQUIPMENTS.SUCCESS,
                                payload: snapshot.val(),
                            })
                        );
                } else {
                    dispatch({ type: GET_EQUIPMENTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_EQUIPMENTS.FAIL });
        }
    };
};

export const getAlerts = () => {
    return (dispatch) => {
        dispatch({ type: GET_VEHICLE_ALERTS.REQUEST });
        try {
            firebase.auth().onAuthStateChanged((user) => {
                if (user) {
                    firebase
                        .database()
                        .ref(`/subjects/alerts/new_report`)
                        .on("value", (snapshot) =>
                            dispatch({
                                type: GET_VEHICLE_ALERTS.SUCCESS,
                                payload: snapshot.val(),
                            })
                        );
                } else {
                    dispatch({ type: GET_VEHICLE_ALERTS.FAIL });
                }
            });
        } catch {
            dispatch({ type: GET_VEHICLE_ALERTS.FAIL });
        }
    };
};

export const setMonth = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_MONTH, payload: date });
    };
};
export const setYear = (date = false) => {
    return (dispatch) => {
        dispatch({ type: SET_YEAR, payload: date });
    };
};

export const redirectTo = (link) => {
    return (dispatch) => {
        dispatch(push(link));
    };
};


/* User Device Info */
export const getUserDeviceInfo = () => {
    return dispatch => {
        dispatch({ type: GET_USER_DEVICE_INFO.REQUEST});

        try {
            firebase.auth().onAuthStateChanged(user => {
                if (user === null) {
                    dispatch({ type: GET_USER_DEVICE_INFO.FAIL });
                } else {
                    firebase 
                        .database()
                        .ref("/users")
                        .on("value", snapshot => {
                            dispatch({
                                type: GET_USER_DEVICE_INFO.SUCCESS,
                                payload: snapshot.val()
                            })
                        })
                }
            })
        } catch (e) {
            dispatch({ type: GET_USER_DEVICE_INFO.FAIL });
        }
    }
}

